module.exports = __webpack_public_path__ + "img/facebook_gold.fddf8f97.png";